// src/config.js (or wherever you prefer to keep it)

const config = {
  // Base URL for your backend API
  API_BASE_URL: 'https://dmsserver.nsfdcdigital.in/api'
  
  // If you test locally, you can easily swap it here:
   //API_BASE_URL: 'http://localhost:5279/api'
};

export default config;